import { UserOffice } from "@/type/core/auth/auth.types";
import { Member } from "@/type/core/offices/offices.types";
import useSignaturePositioning from "@/utils/hooks/useSignaturePositioning";
import PageLayout from "@components/core/layouts/PageLayout";
import Positioning from "@components/core/subComponents/Positioning";
import PositioningError from "@components/core/subComponents/PositioningError";
import { ROUTES } from "@routes/Routes";
import { FunctionComponent } from "react";

interface ResetSignaturePositioningScreenProps {
  members: Member[];
  officesForCgu?: UserOffice[];
}

const ResetSignaturePositioningScreen: FunctionComponent<
  ResetSignaturePositioningScreenProps
> = ({ members, officesForCgu }) => {
  const {
    transactionType,
    files,
    signatories,
    signatures,
    signatureRequirementMode,
    setSignatureRequirementMode,
    manualPositioning,
    setManualPositioning,
    officeId,
    transactionDetail: transaction,
  } = useSignaturePositioning();

  return (
    <PageLayout
      container
      returnRoute={
        files &&
        files.length > 0 &&
        transaction &&
        transaction.status === "draft"
          ? ROUTES.extranet.home.generate()
          : undefined
      }
      isLoading={officesForCgu?.length == 0}
      bodyClassName={
        files &&
        files.length > 0 &&
        transaction &&
        transaction.status === "draft"
          ? ""
          : "mt-0"
      }
    >
      <>
        {files &&
        files.length > 0 &&
        transaction &&
        transaction.status === "draft" ? (
          <Positioning
            members={members}
            officeId={officeId ?? ""}
            transactionType={transactionType ?? "signature"}
            files={files}
            signatories={signatories}
            signatures={signatures}
            signatureRequirementMode={signatureRequirementMode}
            setSignatureRequirementMode={setSignatureRequirementMode}
            manualPositioning={manualPositioning}
            setManualPositioning={setManualPositioning}
          />
        ) : files &&
          files.length > 0 &&
          transaction &&
          transaction.status !== "draft" ? (
          <PositioningError code="21" />
        ) : (
          (!files || (files.length < 1 && transaction)) && (
            <PositioningError code="20" />
          )
        )}
      </>
    </PageLayout>
  );
};

export default ResetSignaturePositioningScreen;
